import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APIS } from '../../config/apis';
import { REQUEST_METHOD, memoActionSet } from '@laramie/ui';
import { standardRequest } from '../../utils/requests';

export const useUsuarios = (props) => {
    const dispatch = useDispatch();
    const cacheRedux = useSelector((state) => state.memo.cache[props.key]);

    const cacheRef = useRef({});
    const hasLoadedAllRef = useRef(false);

    useEffect(() => {
        if (cacheRedux?.value) {
            cacheRef.current = cacheRedux.value;
        }
    }, [cacheRedux]);

    //function
    const resolveUsuarios = (ids) => {
        const idsNuevos = [...new Set(
            ids.filter(id => id && !(id in cacheRef.current))
        )];

        if (idsNuevos.length < 1)
            return;

        standardRequest(
            REQUEST_METHOD.PUT,
            `${APIS.URLS.USUARIO}/ids`,
            { ids: idsNuevos }
        )
        .then(data => {
            const updatedCache = { ...cacheRef.current };
            idsNuevos.forEach(id => updatedCache[id] = '');
            data.forEach(item => updatedCache[item.id] = item.nombreApellido);
            cacheRef.current = updatedCache;
            dispatch(memoActionSet(props.key, updatedCache, -1));
        })
        .catch(error => {});
    };

    const resolveAllUsuarios = () => {
        if (hasLoadedAllRef.current)
            return;

        hasLoadedAllRef.current = true;

        standardRequest(
            REQUEST_METHOD.GET,
            APIS.URLS.USUARIO
        )
        .then(data => {
            const updatedCache = { ...cacheRef.current };
            data.forEach(item => updatedCache[item.id] = item.nombreApellido);
            cacheRef.current = updatedCache;
            dispatch(memoActionSet(props.key, updatedCache, -1));
        })
        .catch(error => {});
    };

    //return
    const getNombreUsuario = (id) => {
        return cacheRef.current[id] ?? '';
    };

    return [getNombreUsuario, resolveUsuarios, resolveAllUsuarios];
};
